import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, DropdownProps } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { DeleteConfirm } from "src/components/DeleteConfirm";

import { ManagementSpecCommonListStore } from ".";

type PropsManagSpecActions = {
  pageStore: ManagementSpecCommonListStore;
};

export const ManagSpecActions: React.FC<PropsManagSpecActions> = observer(
  ({ pageStore }) => {
    const menu: DropdownProps["menu"] = {
      items: [
        {
          key: "delete",
          label: "Удалить",
          danger: true,
          icon: <DeleteOutlined />,
          disabled: !!pageStore.getReason("delete"),
          title: pageStore.getReason("delete"),
          onClick: () => pageStore.setMode("delete"),
        },
      ],
    };
    return (
      <>
        <Dropdown menu={menu}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
        <DeleteConfirm
          content="Удалить выбранные спецификации?"
          open={pageStore.mode === "delete"}
          close={() => pageStore.setMode(null)}
          task={() => pageStore.deleteSelected()}
        />
      </>
    );
  },
);
